<template>
  <HeroSection title="Our team" class="bg-slate-800" bg-src="/images/audi-wheel.webp" />

  <section class="container py-20 text-center">
    <h2>Meet the people behind Driveczech</h2>
    <div class="flex flex-wrap justify-center gap-10 my-10">
      <div v-for="member in members" class="flex flex-col items-center gap-3 pb-5 overflow-hidden border rounded-lg">
        <img :src="member.image" :alt="member.name" class="max-w-md" />
        <h3 class="mt-5 text-xl font-semibold">{{ member.name }}</h3>
        <p class="text-gray-600">{{ member.title }}</p>
        <UButton :to="`mailto:${member.email}`" variant="text" leading-icon="i-heroicons-envelope" aria-label="E-mail">
          {{ member.email }}
        </UButton>
        <UButton :to="`tel:${member.phone.replace(' ', '')}`" variant="text" leading-icon="i-heroicons-phone" aria-label="Telephone">
          {{ member.phone }}
        </UButton>
      </div>
    </div>
  </section>

  <ContentMission />

  <Footer />
</template>

<script setup lang="ts">
const members = [
  {
    name: 'Jan Štim',
    title: 'Chief executive officer',
    image: '/images/jan-stim.webp',
    email: 'jan@driveczech.com',
    phone: '+420 603 427 002',
  },
  {
    name: 'Martin Zada',
    title: 'Chief financial officer',
    image: '/images/martin-zada.webp',
    email: 'martin@driveczech.com',
    phone: '+420 732 643 081',
  },
]
</script>
